import { makeAutoObservable } from "mobx";

const thumbKey = (projectId: string, styleDnaId: string): string => `${projectId}::${styleDnaId}`;

export class ThumbStore {
  thumbs: Record<string, string> = {};

  constructor() {
    makeAutoObservable(this);
  }

  getStyleDnaPanelThumb(projectId: string, styleDnaId: string): string | null {
    if (!projectId || !styleDnaId) {
      return null;
    }

    const v = this.thumbs[thumbKey(projectId, styleDnaId)];
    return typeof v === "string" && v.length > 0 ? v : null;
  }

  setStyleDnaPanelThumb(projectId: string, styleDnaId: string, imageId: string): void {
    if (!projectId || !styleDnaId || !imageId) {
      return;
    }

    this.thumbs = { ...this.thumbs, [thumbKey(projectId, styleDnaId)]: imageId };
  }
}
